import { anuncioFragment } from '@/modules/anuncio-core/data/anuncio-fragment'
import { gql } from 'graphql-request'

export const ANUNCIO_ALEATORIO = gql`
  query AnuncioAleatorioQuery {
    anuncioAleatorio {
      ...AnuncioFragment
    }
  }
  ${anuncioFragment}
`
